var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0529 17.086C21.7014 23.7326 23.2096 16.0432 27.4427 20.2733C31.5238 24.3533 33.8694 25.1707 28.6987 30.3399C28.0511 30.8604 23.936 37.1224 9.47434 22.6648C-4.98913 8.20533 1.26931 4.08607 1.78995 3.43858C6.97311 -1.74493 7.77644 0.614303 11.8575 4.69421C16.0906 8.92616 8.40443 10.4394 15.0529 17.086Z",
    fill: "#F58320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall1);
export default __webpack_public_path__ + "static/media/call1.bc4529205b7738e156ccb6fb976bd58f.svg";
export { ForwardRef as ReactComponent };